export const MAP_URL = {
  login: 'admin/login',
  adminUsers: 'admin/adminUsers',
  paybills: 'admin/paybills',
  insertPaybill: 'admin/insertPaybill',
  request: 'admin/hr/request',
}
